export default __webpack_public_path__ + "static/media/comm 10.afcd4e97.jpeg";